import React from 'react'

function SettingGeneral() {
  return (
    <div className="setting-block">SettingGeneral</div>
  )
}

export default SettingGeneral